<template>
  <header class="header-global">
    <base-nav class="navbar-main" transparent type="" effect="light" expand>
      <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
        <img
          src="img/brand/logo-main.png"
          alt="IBLD"
        />
      </router-link>

      <div class="row" slot="content-header" slot-scope="{ closeMenu }">
        <div class="col-6 collapse-brand text-center">
          <a
            href="https://aula.ibldvenezuela.com/"
          >
            <img src="img/brand/logo.png" />
          </a>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>

      <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
        <!-- <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
          <a
            slot="title"
            href="#"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <i class="ni ni-ui-04 d-lg-none"></i>
            <span class="nav-link-inner--text">Components</span>
          </a>
          <div class="dropdown-menu-inner">
            <a
              href="https://demos.creative-tim.com/vue-argon-design-system/documentation/"
              class="media d-flex align-items-center"
            >
              <div
                class="icon icon-shape bg-gradient-primary rounded-circle text-white"
              >
                <i class="ni ni-spaceship"></i>
              </div>
              <div class="media-body ml-3">
                <h6 class="heading text-primary mb-md-1">Getting started</h6>
                <p class="description d-none d-md-inline-block mb-0">
                  Get started with Bootstrap, the world's most popular framework
                  for building responsive sites.
                </p>
              </div>
            </a>
            <a
              href="https://demos.creative-tim.com/vue-argon-design-system/documentation/"
              class="media d-flex align-items-center"
            >
              <div
                class="icon icon-shape bg-gradient-warning rounded-circle text-white"
              >
                <i class="ni ni-ui-04"></i>
              </div>
              <div class="media-body ml-3">
                <h5 class="heading text-warning mb-md-1">Components</h5>
                <p class="description d-none d-md-inline-block mb-0">
                  Learn how to use Argon compiling Scss, change brand colors and
                  more.
                </p>
              </div>
            </a>
          </div>
        </base-dropdown> -->
        <!-- <base-dropdown tag="li" class="nav-item">
          <a
            slot="title"
            href="#"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <i class="ni ni-collection d-lg-none"></i>
            <span class="nav-link-inner--text">Examples</span>
          </a>
          <router-link to="/landing" class="dropdown-item">Landing</router-link>
          <router-link to="/profile" class="dropdown-item">Profile</router-link>
          <router-link to="/login" class="dropdown-item">Login</router-link>
          <router-link to="/register" class="dropdown-item"
            >Register</router-link
          >
        </base-dropdown> -->
        <!-- <base-dropdown tag="li" class="nav-item">
          <a
            slot="title"
            href="#"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <i class="ni ni-collection d-lg-none"></i>
            <span class="nav-link-inner--text">Consultar notas</span>
          </a>
          <router-link to="/estudiantes" class="dropdown-item"
            >Consultar notas#1</router-link
          >
          <router-link to="/facilitadores" class="dropdown-item"
            >Consultar notas#2</router-link
          >
        </base-dropdown> -->
        <!-- <base-dropdown tag="li" class="nav-item">
          <a
            slot="title"
            href="#"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <i class="ni ni-collection d-lg-none"></i>
            <span class="nav-link-inner--text">Index normal</span>
          </a>
          <router-link to="/components" class="dropdown-item"
            >Componentes</router-link
          >
          
        </base-dropdown> -->

        <li class="nav-item" v-if="!$store.getters['auth/authenticated']">
            <router-link to="/inscripcion" class="nav-link nav-link-icon"
            >Inscripción</router-link
          >
        </li>
        <li class="nav-item" v-if="$store.getters['auth/authenticated']">
            <router-link to="/dashboardinscripciones" class="nav-link nav-link-icon"
            >Inscripciones</router-link
          >
        </li>
        <li class="nav-item" v-if="$store.getters['auth/authenticated']">
            <router-link to="/catedras" class="nav-link nav-link-icon"
            >Cátedras</router-link
          >
        </li>


        <!-- <base-dropdown tag="li" class="nav-item" v-if="$store.getters['auth/authenticated']">
          <a
            slot="title"
            href="#"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <i class="ni ni-collection d-lg-none"></i>
            <span class="nav-link-inner--text">Gestion de usuarios</span>
          </a>
          <router-link to="/estudiantes" class="dropdown-item"
            >Listado de estudiantes</router-link
          >
          <router-link to="/facilitadores" class="dropdown-item"
            >Listado de facilitadores</router-link
          >
        </base-dropdown>
        <base-dropdown tag="li" class="nav-item" v-if="$store.getters['auth/authenticated']">
          <a
            slot="title"
            href="#"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <i class="ni ni-collection d-lg-none"></i>
            <span class="nav-link-inner--text">Catedras</span>
          </a>
          <button @click="test" class="dropdown-item">
            Gestión de catedras
          </button>
          <router-link to="/" class="dropdown-item">Otro</router-link>
        </base-dropdown>
        <base-dropdown tag="li" class="nav-item" v-if="$store.getters['auth/authenticated']">
          <a
            slot="title"
            href="#"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <i class="ni ni-collection d-lg-none"></i>
            <span class="nav-link-inner--text">Administración</span>
          </a>
          <router-link to="/niveles" class="dropdown-item"
            >Niveles</router-link
          >
        </base-dropdown> -->

        <base-dropdown tag="li" class="nav-item">
          <a
            slot="title"
            href="#"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <i class="ni ni-collection d-lg-none"></i>
            <span class="nav-link-inner--text">Perfil</span>
          </a>
          <button @click="userAuth" class="dropdown-item">
            {{ nombreAutenticar }}
          </button>
          <!-- <button @click="test" class="dropdown-item">test</button> -->
        </base-dropdown>
        
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
  },
  computed: {
    nombreAutenticar() {
      if (this.$store.getters["auth/authenticated"]) {
        return "Salir";
      } else {
        return "Iniciar Sesion";
      }
    },
  },
  methods: {
    userAuth() {
      if (this.$store.getters["auth/authenticated"]) {
        //this.$store.commit('SET_OVERLAY', true);
        this.$store
          .dispatch("auth/logout")
          .then(() => {
            this.$router.push({ path: "/login" });
            // this.$store.commit('SET_LOAD', false);
          })
          .catch(() => {
            this.$store.commit("SET_OVERLAY", false);
          });
      }else{
          this.$router.push({ path: "/login" });
      }
    },
    test() {
      console.log();
    },
  },
};
</script>
<style></style>
